/* eslint-disable import/no-anonymous-default-export */

import {createIcon} from '../util/helpers/icon';
import ICONS from '../dist/icons.json';

const {
	adobe,
	aftereffects,
	airbnb,
	airtable,
	amazon,
	americanexpress,
	android,
	angellist,
	angular,
	apollo,
	apple,
	applepay,
	appstore,
	atlassian,
	audible,
	auth0,
	ava,
	awesome,
	aws,
	awsapigateway,
	awscloudformation,
	awscloudfront,
	awscloudwatch,
	awscognito,
	awsdynamodb,
	awsec2,
	awsiam,
	awsicon,
	awslambda,
	awsrds,
	awsroute53,
	babel,
	basecamp,
	behance,
	bitbucket,
	bitcoin,
	bootstrap,
	bower,
	browserify,
	browserstack,
	buffer,
	chrome,
	cloudflare,
	cockroachdb,
	codecademy,
	codecov,
	codepen,
	codesandbox,
	composer,
	confluence,
	cordova,
	couchdb,
	creativecloud,
	css3,
	d3,
	deno,
	designernews,
	digitalocean,
	dinersclub,
	discord,
	discover,
	dribbble,
	drift,
	dropbox,
	egghead,
	electron,
	ember,
	facebook,
	figma,
	firebase,
	firefox,
	foundation,
	gatsby,
	git,
	github,
	gitlab,
	gmail,
	google,
	googleplaystore,
	googletagmanager,
	graphql,
	grunt,
	gulp,
	hackernews,
	heroku,
	herokusolid,
	html5,
	hugo,
	hyper,
	illustrator,
	indesign,
	instagram,
	intercom,
	internetexplorer,
	invision,
	ionic,
	java,
	javascript,
	jcb,
	jest,
	jetbrains,
	jira,
	jquery,
	jsfiddle,
	jupyter,
	laravel,
	lavelicon,
	linkedin,
	linux,
	magento,
	mailchimp,
	mailgun,
	marvel,
	mastercard,
	materialui,
	mdn,
	medium,
	meetup,
	microsoft,
	mongodb,
	mysql,
	namecheap,
	netflix,
	netlify,
	next,
	nginx,
	node,
	npm,
	nuxt,
	patreon,
	patreonold,
	paypal,
	percona,
	photoshop,
	php,
	pinterest,
	pocket,
	postgresql,
	premierpro,
	prettier,
	prisma,
	producthunt,
	puppeteer,
	python,
	quora,
	rackspace,
	rails,
	react,
	reddit,
	redis,
	redux,
	rollup,
	ruby,
	rust,
	sanity,
	sass,
	segment,
	serverless,
	shopify,
	sketch,
	skype,
	slack,
	smashingmagazine,
	snapchat,
	socket,
	soundcloud,
	spotify,
	square,
	squarespace,
	stackoverflow,
	storybook,
	stripe,
	svelte,
	swift,
	tailwind,
	telegram,
	tensorflow,
	tinder,
	travis,
	trello,
	tumblr,
	twitch,
	twitter,
	typeform,
	typescript,
	ubuntu,
	unionpay,
	unity,
	vim,
	vimeo,
	visa,
	visualstudiocode,
	vue,
	webpack,
	webstorm,
	woocommerce,
	wordpress,
	yarn,
	youtube,
	zapier,
	zeplin
} = Object.keys(ICONS)
	.map(icon => createIcon(
		icon,
		ICONS[icon]
	))

/* eslint-disable-next-line unicorn/no-reduce */
	.reduce((object, icon) => {
		object[icon.name] = icon;
		return object;
	}, {});

export default {
	adobe,
	aftereffects,
	airbnb,
	airtable,
	amazon,
	americanexpress,
	android,
	angellist,
	angular,
	apollo,
	apple,
	applepay,
	appstore,
	atlassian,
	audible,
	auth0,
	ava,
	awesome,
	aws,
	awsapigateway,
	awscloudformation,
	awscloudfront,
	awscloudwatch,
	awscognito,
	awsdynamodb,
	awsec2,
	awsiam,
	awsicon,
	awslambda,
	awsrds,
	awsroute53,
	babel,
	basecamp,
	behance,
	bitbucket,
	bitcoin,
	bootstrap,
	bower,
	browserify,
	browserstack,
	buffer,
	chrome,
	cloudflare,
	cockroachdb,
	codecademy,
	codecov,
	codepen,
	codesandbox,
	composer,
	confluence,
	cordova,
	couchdb,
	creativecloud,
	css3,
	d3,
	deno,
	designernews,
	digitalocean,
	dinersclub,
	discord,
	discover,
	dribbble,
	drift,
	dropbox,
	egghead,
	electron,
	ember,
	facebook,
	figma,
	firebase,
	firefox,
	foundation,
	gatsby,
	git,
	github,
	gitlab,
	gmail,
	google,
	googleplaystore,
	googletagmanager,
	graphql,
	grunt,
	gulp,
	hackernews,
	heroku,
	herokusolid,
	html5,
	hugo,
	hyper,
	illustrator,
	indesign,
	instagram,
	intercom,
	internetexplorer,
	invision,
	ionic,
	java,
	javascript,
	jcb,
	jest,
	jetbrains,
	jira,
	jquery,
	jsfiddle,
	jupyter,
	laravel,
	lavelicon,
	linkedin,
	linux,
	magento,
	mailchimp,
	mailgun,
	marvel,
	mastercard,
	materialui,
	mdn,
	medium,
	meetup,
	microsoft,
	mongodb,
	mysql,
	namecheap,
	netflix,
	netlify,
	next,
	nginx,
	node,
	npm,
	nuxt,
	patreon,
	patreonold,
	paypal,
	percona,
	photoshop,
	php,
	pinterest,
	pocket,
	postgresql,
	premierpro,
	prettier,
	prisma,
	producthunt,
	puppeteer,
	python,
	quora,
	rackspace,
	rails,
	react,
	reddit,
	redis,
	redux,
	rollup,
	ruby,
	rust,
	sanity,
	sass,
	segment,
	serverless,
	shopify,
	sketch,
	skype,
	slack,
	smashingmagazine,
	snapchat,
	socket,
	soundcloud,
	spotify,
	square,
	squarespace,
	stackoverflow,
	storybook,
	stripe,
	svelte,
	swift,
	tailwind,
	telegram,
	tensorflow,
	tinder,
	travis,
	trello,
	tumblr,
	twitch,
	twitter,
	typeform,
	typescript,
	ubuntu,
	unionpay,
	unity,
	vim,
	vimeo,
	visa,
	visualstudiocode,
	vue,
	webpack,
	webstorm,
	woocommerce,
	wordpress,
	yarn,
	youtube,
	zapier,
	zeplin
};
